import styled from "styled-components";
import Errorlogo from "../../../images/error-logo.svg";
import Infologo from "../../../images/info-logo.svg";
import ErrorRedlogo from "../../../images/error-red-icon.svg";
import SUCCESSICON from "../../../images/feedbackSuccess.svg";
import ErrorCloseIcon from "../../../images/error-close-icon.svg";

export const Error = styled.div`
position: absolute;
width: 100%;
max-width: 70%;
left: 0;
right: 0;
top:5%;
margin-left:auto;
margin-right:auto;
background: rgba(0, 0, 0, 0.7);
border: 1px solid #000000;
box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
border-radius: 10px;
z-index:12;
padding:22px;
@media screen and (max-width: 520px){
    background: rgba(0, 0, 0, 1);
    }
    @media screen and (max-width: 740px){
        position: fixed;
        top:8vh;
    }
@media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: landscape) 
{
    position: fixed;
    top:8vh;
}
@media only screen and (min-device-width: 750px) and (max-device-width: 1199px) and (orientation: portrait) 
{
    position: fixed;
    top:8vh;
}
& h2{
    position:relative;
    font-style: normal;
    font-weight: 400;
    font-size: 26px;
    line-height: 120%;
    letter-spacing: 0.01em;
    color: #ffffff;
}
& p{
    position:relative;
    // height: 21.4px;
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 120%;
    letter-spacing: 0.01em;    
    color: #FFFFFF;
}
& h2 span{
    position:relative;
    padding-left:40px;
}
& h2 span:before{
    position: absolute;
    content:"";
    width: 35px;
    height: 30px;
    left: 0px;
    top: -3px;
    background:url(${Errorlogo}) 0 0;
    backgroung-repeat: no-repeat;
    background-size:35px;
}
& h2 span.callUsInfo:before{
    position: absolute;
    content:"";
    width: 35px;
    height: 35px;
    left: 0px;
    top: -3px;
    background:url(${Infologo}) 0 0;
    background-size:35px;
    backgroung-repeat: no-repeat;
}
& h2 span.getHelpFeedbackSuccess:before{
    position: absolute;
    content:"";
    width: 35px;
    height: 35px;
    left: 0px;
    top: -3px;
    background:url(${SUCCESSICON}) 0 0;
    background-size:35px;
}
& h2 span.getHelpFeedbackError:before{
    position: absolute;
    content:"";
    width: 35px;
    height: 30px;
    left: 0px;
    top: -3px;
    background:url(${ErrorRedlogo}) 0 0;
    background-size:35px;
}

@media screen and (max-width: 720px){
    top:15vh;
    &{
        min-height: 10%;
        height:max-content;
        max-width:90%;
        top:30px;
        overflow-y: auto;
    }
} 
`
export const ErrorClose = styled.a`
position: absolute;
width: 18px;
height: 20.27px;
right: 15px;
top: 16px;
background:url(${ErrorCloseIcon}) 0 0;
backgroung-repeat: no-repeat;
`
export const invalidText = styled.div`
position: absolute;
width: 18px;
height: 20.27px;
right: 15px;
top: 16px;
background:url(${ErrorCloseIcon}) 0 0;
backgroung-repeat: no-repeat;
`
export const ProceedText = styled.p`
cursor: pointer;
text-decoration: underline;
`
export const CancelText = styled.p`
cursor: pointer;
margin-left: 10px;
text-decoration: underline;
`
export const ErrorOkButton = styled.button`
cursor: pointer;
background-color: unset;
color: white;
text-decoration: underline;
`
export const ErrorCancelButton = styled.button`
cursor: pointer;
background-color: unset;
color: white;
text-decoration: underline;
margin-left: 3%;
`
export const PageError = styled.div`
height: 100vh;
display: flex;
align-items: center;
justify-content: center;
`
